export default {
	textColor: "#555555",
	titleColor: "#333333",
	primaryColor: "#1da7e7",
	borderColor: "#d7d7d7",
	backgroundColor: "#f0f0f0"
};
